import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import DuAn from './du-an';
import DuAnDetail from './du-an-detail';
import DuAnUpdate from './du-an-update';
import DuAnDeleteDialog from './du-an-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={DuAnUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={DuAnUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={DuAnDetail} />
      <ErrorBoundaryRoute path={match.url} component={DuAn} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={DuAnDeleteDialog} />
  </>
);

export default Routes;
